import axios from 'axios';

const dev = 'https://miv.musicisvivid.com/api/';

export const API = axios.create({
    baseURL: dev,
    timeout: 30000, // Set your default timeout here (30 seconds in this example)
    headers: {
       
     
       
    }
});


API.interceptors.request.use(function (config) {
    const token = localStorage.getItem('Token');
    // const token = localStorage.getItem('Token');
    // var ip = localStorage.getItem('ipdata');
    // var locale=localStorage.getItem('locale');
    if ( token != null ) {
        config.headers.accessToken = `${token}`;
    }
    // if ( token != null ) {
    //     config.headers.Authorization = `Bearer ${token}`;
    // }
    // if(ip != null ){
    //     config.headers.ip = JSON.parse(localStorage.getItem("ipdata")).ip;
    // }
    // if(locale != null ){
    //     config.headers.locale = locale;
    // }
    return config;
}, function(err) {
    return Promise.reject(err);
});